import Skeleton from 'react-loading-skeleton'
import React from 'react'

const InstagramAccountSkeleton = () => {
  return (
    <>
      <br />
      {/*Checkbox with title skeleton*/}
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: '16px' }}>
          <Skeleton style={{ height: 16, marginRight: 10 }} />
        </div>
        <div style={{ width: '92%' }}>
          <Skeleton style={{ height: 15 }} />
        </div>
      </div>

      {/*text description skeleton*/}
      <Skeleton style={{ height: 50, marginTop: 10 }} />
    </>
  )
}
export default InstagramAccountSkeleton
